import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./CorporatePlans.scss";
import doctor from "../../../assets/doctor tron.png";
import GetStartedModal from "../../GetStartedModal";

const benefits = [
  "Reduce employee healthcare costs",
  "Improve workforce productivity",
  "Access to top clinics & specialists",
];

const CorporatePlans = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box className="corporate-section">
      <Box className="corporate-section__content">
        <Typography
          variant="h4"
          className="corporate-section__header"
          style={{
            fontSize: isMobile ? "2.0rem" : "2.5rem;",
            fontWeight: "900",
          }}
        >
          Customized OPD Plans for Corporates
        </Typography>
        <Typography
          variant="subtitle1"
          className="corporate-section__subheader"
        >
          Boost employee well-being with budget-friendly OPD solutions.
        </Typography>

        <List className="corporate-section__list">
          {benefits.map((item, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <CheckCircleIcon className="icon" />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        <Typography className="corporate-section__description">
          We provide tailored OPD solutions to meet the healthcare needs of your
          team.
        </Typography>

        <Button
          onClick={handleOpen}
          variant="contained"
          className="corporate-section__cta"
          style={{
            backgroundColor: "#d83f87",
            marginTop: isMobile ? "15px" : "15px",
            // marginLeft: isMobile ? "52px" : "70px",
            marginBottom: isMobile ? "10px" : "",
          }}
        >
          Talk to a Tron Representative
        </Button>
      </Box>
      <GetStartedModal open={open} handleClose={handleClose} />
      <Box className="corporate-section__image">
        <img src={doctor} alt="Corporate OPD Plans" />
      </Box>
    </Box>
  );
};

export default CorporatePlans;
